import { useEffect, useState, useMemo } from 'react';
import { UrlApi } from '../../../../services/apirest';
import MaterialReactTable from 'material-react-table';
import { MRT_Localization_ES } from "material-react-table/locales/es";
import { MenuItem, Typography, Box, ListItemIcon, Divider, createTheme, ThemeProvider, useTheme, Container, Grid } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import FileUploadMultiple from '../../../../services/UploadFiles';
import { Assignment, Preview, Delete } from '@mui/icons-material';
import EditarOrden from './EditarOrden';
import Openpdf from '../../OpenPdf';
import DatosOrden from './DatosOrden';
import { logEventos } from '../../../../services/services';
import DeleteDialog from '../../../Dialogs/DeleteDialog';
import moment from 'moment';

export default function OrdenesGeneradas(props) {
    const [ordenes, setOrdenes] = useState(null);
    const globalTheme = useTheme();
    const [openclose, setOpenClose] = useState(false);
    const [datosFormulario, setDatosFormulario] = useState({});
    const [editar, setEditar] = useState(false);
    const [tabla, setTabla] = useState(true);
    const [openpdf, setOpenpdf] = useState(false);
    const [open, setOpen] = useState(false);
    const [openDelete, setopenDelete] = useState(false);
    const [notify, setNotify] = useState({
        open: false,
        mensaje: "",
        severity: "",
        color: "",
    });

    const obtenerOrdenesCompra = () => {
        // fetch(UrlApi + '/ordencompra/all_generadas')
        fetch(UrlApi + '/ordencompra/actualizada/all_generadas')
            .then(data => data.json())
            .then(data => setOrdenes(data))
    };


    useEffect(() => {
        obtenerOrdenesCompra()
    }, [tabla]);



    const columns = useMemo(() =>
        [{ header: '#', accessorKey: 'idordencompra', size: 40 },
        { header: 'Proveedor', accessorFn: (ordenes) => ordenes.nombre_fantasia ? ordenes.nombre_fantasia : ordenes.razon_social, },
        { header: 'Pago', accessorFn: (ordenes) => ordenes.pago_anticipado === 1 ? 'Anticipado' : "No Anticipado", size: 80 },
        { header: 'Entrega', accessorKey: 'fecha_entrega', size: 100, type: "date", accessorFn: (oc) => oc.fecha_entrega ? moment(oc.fecha_entrega).format("DD-MM-YYYY") : "No hay registro" },
        {
            header: 'Estado',
            accessorKey: 'valor_estado',
            accessorFn: (oc) =>
                oc.origen === "manual"
                    ? `${oc.valor_estado}`
                    : `${oc.valor_estado}${oc.ids_requerimientos
                        ? ` (Requerimiento ${Array.isArray(oc.ids_requerimientos) ? oc.ids_requerimientos.join(", ") : oc.ids_requerimientos})`
                        : ""
                    }`,
        }
        ], []);

    const tableTheme = useMemo(
        () =>
            createTheme({
                palette: {
                    mode: globalTheme.palette.mode,
                    primary: globalTheme.palette.primary, //primary color for the table
                    info: {
                        main: "rgb(255,122,0)", //add in a custom color for the toolbar alert background stuff
                    },
                    background: {
                        default:
                            globalTheme.palette.mode === "light"
                                ? "rgb(234, 239, 241)"
                                : "#000", //pure black table in dark mode for fun
                    },
                },
                typography: {
                    button: {
                        textTransform: "none", //customize typography styles for all buttons in table by default
                        fontSize: "1rem",
                    },
                },
                components: {
                    MuiTooltip: {
                        styleOverrides: {
                            tooltip: {
                                fontSize: "0.8rem", //larger tooltip font size                                
                            },
                        },
                    },
                },

            }), [globalTheme]);

    const muiSearchTextFieldProps = {
        placeholder: "Buscar..",
        sx: { minWidth: "18rem", backgroundColor: "#ffffff" },
        variant: "outlined",
        color: "success",
        size: "small",
    };

    const tableHeadCellProps = {
        align: "center",
        sx: {
            fontSize: 16,
            color: "white",
            fontWeight: "normal",
            backgroundColor: "#2471A3",
            borderColor: "black",
        },
    };

    const initialState = {
        density: "compact",
        showGlobalFilter: true,
        pagination: { pageIndex: 0, pageSize: 10 }
    };

    const rowBg = {
        102: "#ec7063",
    };

    const handleEditar = (datosDeLaLinea) => {
        setEditar(true)
        setDatosFormulario(datosDeLaLinea)
        setTabla(false)
        setOpen(false)
        props.tab(false)
    };

    const handleOpenpdf = (datos) => {
        setOpenpdf(true)
        setDatosFormulario(datos)
        setTabla(false)
        setOpen(false)
        props.tab(false)
    };

    const toggleDrawer = (row, newOpen) => () => {
        setOpen(true);
        setDatosFormulario(row)
    };

    const handleAbrirDialogEliminar = (datosDeLaLinea) => {
        setDatosFormulario(datosDeLaLinea)
        setTabla(true)
        setopenDelete(true)
    };

    const handleDeleteOrden = async (e) => {
        e.preventDefault();
        try {
            const response = await fetch(
                `${UrlApi}/ordencompra/transaccion/${datosFormulario.uuid_ordencompra}`,
                {
                    method: "DELETE",
                    headers: { "Content-Type": "application/json" },
                }
            );

            if (!response.ok) {
                // si hubo error en el backend
                const errorData = await response.json();
                throw new Error(errorData.error || "Error al eliminar la orden");
            }

            const data = await response.json();
            alert(data.message || "Orden de compra eliminada correctamente");

        } catch (error) {
            console.error("Error al eliminar orden:", error);
            alert("Hubo un error al eliminar la orden");
        } finally {
            // Esto se ejecuta SIEMPRE
            setopenDelete(false)
            setTabla(true);

            obtenerOrdenesCompra();
            logEventos(
                `Eliminar orden de compra ${datosFormulario.idordencompra}`,
                "Ordenes Generadas",
                "GenerarOrdenes",
                localStorage.getItem("user")
            );
        }
    };


    return (
        <div>
            <Container maxWidth="xl" mt={1} mb={2}>
                {ordenes && tabla ? (
                    <Box mt={2} boxShadow={3} mb={5}>
                        <ThemeProvider theme={tableTheme}>
                            <MaterialReactTable
                                enableColumnResizing
                                columns={columns}
                                data={ordenes}
                                enableRowActions
                                initialState={initialState}
                                positionActionsColumn="last"
                                muiTableHeadCellProps={tableHeadCellProps}
                                muiTableBodyCellProps={({ row }) => ({
                                    align: "left",
                                    sx: {
                                        backgroundColor:
                                            rowBg[row.original.id_estado] ?? "#fff",
                                        color: "black",
                                        borderColor: "black",
                                    },
                                })}
                                enableColumnActions={false}
                                enableDensityToggle={false}
                                muiSearchTextFieldProps={muiSearchTextFieldProps}
                                renderTopToolbarCustomActions={() => (
                                    <Typography variant="poster" fontSize={26}>
                                        <Assignment sx={{ size: 19 }} ></Assignment>
                                        Ordenes
                                    </Typography>
                                )}
                                layoutMode="grid"
                                localization={MRT_Localization_ES}
                                enableColumnDragging={false}
                                renderRowActionMenuItems={({ closeMenu, row }) => [
                                    <MenuItem
                                        style={{
                                            display:
                                                (row.original.id_estado === 89) || (row.original.id_estado === 102)
                                                    ? null
                                                    : "none",
                                        }}
                                        key={0}
                                        onClick={() => {
                                            handleEditar(row.original)
                                            closeMenu();
                                        }}
                                        sx={{ m: 0 }}>
                                        <ListItemIcon>
                                            <EditIcon color="primary" />
                                        </ListItemIcon>
                                        Editar
                                    </MenuItem>,
                                    <Divider />,
                                    <MenuItem
                                        disabled={(row.original.id_estado !== 81) && (row.original.id_estado !== 186)}
                                        key={1}
                                        onClick={() => {
                                            handleOpenpdf(row.original)
                                            closeMenu();
                                        }}
                                        sx={{ m: 0 }}>
                                        <ListItemIcon>
                                            <Preview color="secondary" />
                                        </ListItemIcon>
                                        Visualizar
                                    </MenuItem>,
                                    <Divider />,
                                    <MenuItem
                                        disabled={row.original.id_estado === 81 || row.original.id_estado === 186}
                                        key={1}
                                        onClick={() => {
                                            handleAbrirDialogEliminar(row.original)
                                            closeMenu();
                                        }}
                                        sx={{ m: 0 }}>
                                        <ListItemIcon>
                                            <Delete color="error" />
                                        </ListItemIcon>
                                        Eliminar
                                    </MenuItem>,

                                ]}
                                enableColumnFilters={false}
                                enableHiding={false}
                                enableFacetedValues
                                enableMultiRowSelection={false}
                                muiToolbarAlertBannerProps={false}
                                muiTableBodyRowProps={({ row }) => ({
                                    onClick: () => {
                                        row.getToggleSelectedHandler()
                                        toggleDrawer(row.original)()
                                    },
                                    sx: {
                                        cursor: 'pointer'
                                    }
                                })} />
                        </ThemeProvider>
                    </Box>
                ) : null}
                {open ?
                    <Grid key={datosFormulario.idordencompra}>
                        <DatosOrden datos={datosFormulario} anchor={setOpen} />
                    </Grid>
                    : null}
            </Container>
            {openclose ?
                <FileUploadMultiple fileId={ordenes.uuid_ordencompra} openclose={true}
                /> : null}

            {editar ? <EditarOrden datos={datosFormulario} tabla={setTabla} editar={setEditar} tabs={props.tab} ></EditarOrden> : null}

            {openpdf ?
                <Openpdf
                    datos={datosFormulario}
                    uuid={datosFormulario.uuid_ordencompra}
                    open={setOpenpdf}
                    tabla={setTabla}
                    tab={props.tab} /> : null}

            {openDelete &&
                <DeleteDialog
                    title={"Eliminar orden"}
                    confirmText={`¿Confirma que desea eliminar la orden de compra ${datosFormulario.idordencompra}?`}
                    btnText={"Confirmar"}
                    notify={notify}
                    setNotify={setNotify}
                    open={openDelete}
                    setOpen={setopenDelete}
                    guardar={handleDeleteOrden} />}

        </div>
    )

}